import { unquote } from '@imcc/utilities';

export class ContentDisposition {
  constructor(private headerString: string) {}

  get filename(): string {
    return unquote(this.contentInfo.filename || '');
  }

  private get contentInfo() {
    const entries = this.headerString.split(';').map((str) => str.trim().split('='));
    return Object.fromEntries(entries);
  }
}
